import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const DocumentLoader = () => {
  const { downloadLoading } = useSelector(
    (state) => state.downloadDocuments
  );

  const [isClosed, setIsClosed] = useState(false);
  useEffect(() => {
    if (downloadLoading) {
      setIsClosed(false);
    }
  }, [downloadLoading]);

  const shouldShow = downloadLoading && !isClosed;

  if (!shouldShow) return null;

  return (
  <div className="toaster toaster--show">
      <div className="toaster__content">
        <div className="toaster__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0ZM11 10V6H9V10H6L10 14L14 10H11Z" fill="#2196F3"/>
          </svg>
        </div>
        <div className="toaster__text">
          <h3 className="title">Downloading<span></span></h3>
          <p className="para">Your document is downloading. Please wait.</p>
        </div>
        <button className="btnClose" onClick={() => setIsClosed(true)}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.00033 17.3332C4.39783 17.3332 0.666992 13.6023 0.666992 8.99984C0.666992 4.39734 4.39783 0.666504 9.00033 0.666504C13.6028 0.666504 17.3337 4.39734 17.3337 8.99984C17.3337 13.6023 13.6028 17.3332 9.00033 17.3332ZM9.00033 7.8215L6.64366 5.464L5.46449 6.64317L7.82199 8.99984L5.46449 11.3565L6.64366 12.5357L9.00033 10.1782L11.357 12.5357L12.5362 11.3565L10.1787 8.99984L12.5362 6.64317L11.357 5.464L9.00033 7.8215Z" fill="#B0B0B0"/>
          </svg>
        </button>  
      </div>  
    </div>
  );
};

export default DocumentLoader;
